import {useState} from 'react';
import {Button, ButtonProps} from '@mantine/core';
import {AiOutlinePlayCircle} from 'react-icons/ai';
import {StartExecutionDrawer} from '../drawers/StartExecutionDrawer.tsx';

interface StartExecutionButtonProps extends ButtonProps {
    playbookId: string;
    playbookName?: string;
}

export const StartExecutionButton = ({
                                         playbookId,
                                         playbookName,
                                         ...buttonProps
                                     }: StartExecutionButtonProps) => {

    const [opened, setOpened] = useState(false);

    if (opened) {
        return (
            <StartExecutionDrawer
                playbookId={playbookId}
                playbookName={playbookName}
                opened={opened}
                onClose={() => setOpened(false)}
            />
        );
    }

    return (
        <Button
            leftSection={<AiOutlinePlayCircle/>}
            onClick={() => setOpened(true)}
            {...buttonProps}
        >
            Start Execution
        </Button>
    );
};
